export const BUSINESS_CASE_TIMELINE_EVENT_KINDS = [
  'message',
  'call',
  'email',
  'sms',
  'visit',
  'offerSent',
  'offerOpened',
  'testDrivePlanned',
  'testDriveCancelled',
  'testDriveCompleted',
  'taskCreated',
  'taskFinished',
  'depositIssued',
  'depositPaid',
  'invoiceIssued',
  'invoicePaid',
  'lifecycle',
] as const;
